import { useEffect } from 'react'
import { useControlStore } from '@editorStores'

/**
 * Make the IFC/GLB model translucent (via the existing `gltfModelTranslucent` toggle, opacity from
 * `ifcTransparentOpacity`) while the calling component is mounted — e.g. the guided import/edit
 * steps so elements stay visible while working — and reset the toggle off on unmount.
 */
const useTranslucentGltfModel = (): void => {
  const setGltfModelTranslucent = useControlStore(state => state.setGltfModelTranslucent)

  useEffect(() => {
    setGltfModelTranslucent(true)
    return () => setGltfModelTranslucent(false)
  }, [setGltfModelTranslucent])
}

export default useTranslucentGltfModel
